import colors from 'assets/theme/base/colors';

const { text } = colors;

const muiDataGrid = {
  styleOverrides: {
    columnHeaders: {
      color: text.main
    }
  }
};

export default muiDataGrid;
